import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Row,
  Tooltip,
} from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UploadButton from "./uploadButton";
import { validateFileSize } from "../fileValidation";
import { upload_file } from "../../../services/uploads";
import { useWatch } from "antd/es/form/Form";

type Props = {
  form: any;
  task_id: any;
};

const DatasetPage = (props: Props) => {
  const { t } = useTranslation();

  const [uploading, setUploading] = useState<{ [key: number]: boolean }>({});

  const datasetprivate = useWatch("datasetprivate", props.form);

  const DeleteButtonWithConfirmSubdata = ({ onDelete = () => {} }) => (
    <Popconfirm
      title={t("Alert delete title")}
      description={t("Alert delete detail")}
      okText={t("yes")}
      cancelText={t("no")}
      onConfirm={() => {
        // ✅ ให้แน่ใจว่ากด "ใช่" แล้วถึงลบ
        onDelete();
      }}
    >
      <Button
        style={{
          backgroundColor: "#B31312",
          color: "white",
        }}
        icon={<DeleteOutlined />}
      />
    </Popconfirm>
  );

  const handleNumberInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = /^[0-9]$/; // อนุญาตเฉพาะตัวเลข 0-9
    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <div className="add-task-body-layout">
      {/* dataset public */}
      <Row gutter={24} style={{ marginTop: 20 }}>
        <Card
          title={t("Training Dataset (Public)")}
          style={{
            width: "100%",
            backgroundColor: "#F3F3F1",
            borderColor: "#cccccc",
          }}
        >
          <Alert
            showIcon
            style={{ marginBottom: 10 }}
            message={`${t("The file size must not exceed")} 1024 * 537`}
            type="info"
            closable
          />
          <Form.List name="datasetpublic" initialValue={[]}>
            {(fields, { add, remove }) => (
              <>
                {/* แสดงเฉพาะปุ่ม Add Dataset หาก fields.length === 0 */}
                {fields.length === 0 && (
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() =>
                        add({
                          name: "",
                          desciption: "",
                          link: "",
                          samples: 0,
                        })
                      }
                      icon={<PlusOutlined />}
                      style={{ width: "100%" }}
                    >
                      {t("Add Dataset")}
                    </Button>
                  </Form.Item>
                )}

                {/* แสดงฟิลด์รายการ */}
                {fields.map((field, index) => (
                  <Form.Item key={field.key} required={false}>
                    <Row gutter={8} align="top">
                      <Col xs={24} sm={3} md={3} lg={3} span={3}>
                        <span>
                          {index + 1}. {t("Dataset")} :{" "}
                        </span>
                      </Col>
                      <Col span={21}>
                        <Form.Item
                          {...field}
                          name={[field.name, "name"]}
                          rules={[
                            {
                              required: true,
                              message: "Please input display dataset!",
                            },
                          ]}
                          noStyle
                        >
                          <Input
                            placeholder="Id"
                            autoComplete="off"
                            onKeyPress={(event) => {
                              const regex = /^[A-Za-z0-9_]$/;
                              if (!regex.test(event.key)) {
                                event.preventDefault(); // บล็อกการพิมพ์อักขระที่ไม่ตรงเงื่อนไข
                              }
                            }}
                            onPaste={(event) => {
                              const paste = (
                                event.clipboardData || window.Clipboard
                              ).getData("text");
                              if (!/^[A-Za-z0-9_]+$/.test(paste)) {
                                event.preventDefault(); // บล็อกการวางข้อความที่มีอักขระไม่ตรงเงื่อนไข
                              }
                            }}
                          />
                        </Form.Item>
                        <div
                          style={{
                            color: "#888",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {t(
                            "Only letters, numbers, and underscores ( _ ) are allowed",
                          )}
                        </div>
                      </Col>
                      <Col xs={24} sm={3} md={3} lg={3} span={3}></Col>
                      <Col span={21} style={{ marginTop: "10px" }}>
                        <Form.Item
                          {...field}
                          name={[field.name, "desciption"]}
                          rules={[
                            { required: false },
                            {
                              message: "Please select a desciption",
                            },
                          ]}
                          noStyle
                        >
                          <Input placeholder="Display dataset name" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={3} md={3} lg={3} span={3}></Col>
                      <Col span={16} style={{ marginTop: "10px" }}>
                        <Form.Item
                          {...field}
                          name={[field.name, "link"]}
                          rules={[
                            { required: false },
                            {
                              type: "url",
                              warningOnly: true,
                            },
                            {
                              message: "Please input a valid link",
                            },
                          ]}
                          noStyle
                        >
                          <Input
                            placeholder="https://www.example.com/dataset1"
                            disabled={
                              !!props.form.getFieldValue("datasetpublic")[index]
                                ?.link
                            }
                          />
                        </Form.Item>
                      </Col>
                      {/* <Col xs={24} sm={3} md={3} lg={3} span={3}></Col> */}
                      <Col span={5} style={{ marginTop: "10px" }}>
                        {props.form.getFieldValue("datasetpublic")?.[index]
                          ?.link ? (
                          // หากมีข้อมูลในฟิลด์ link จะแสดงปุ่ม Clear Path
                          <div>
                            <Tooltip placement="bottom" title="Clear Path">
                              <Button
                                onClick={() => {
                                  // ล้างค่า link ใน datasetpublic
                                  const datasetpublic =
                                    props.form.getFieldValue("datasetpublic") ||
                                    [];
                                  datasetpublic[index].link = null; // ล้างค่า link ในรายการที่กำหนด
                                  props.form.setFieldsValue({
                                    datasetpublic,
                                  }); // อัปเดตค่าในฟอร์ม
                                }}
                                icon={"X"}
                                danger
                              ></Button>
                            </Tooltip>
                            <Tooltip placement="bottom" title="Delete">
                              <DeleteButtonWithConfirmSubdata
                                onDelete={() => remove(field.name)}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          // หากยังไม่มีข้อมูลในฟิลด์ link จะแสดงปุ่ม Upload
                          <div>
                            <Tooltip placement="bottom" title="Upload2">
                              <UploadButton
                                validateFileSize={validateFileSize}
                                uploading={uploading}
                                setUploading={setUploading}
                                upload_file={upload_file}
                                form={props.form}
                                index={index}
                                task_id={props.task_id}
                                type="public"
                              />
                            </Tooltip>

                            <Tooltip placement="bottom" title="Delete">
                              <DeleteButtonWithConfirmSubdata
                                onDelete={() => remove(field.name)}
                              />
                            </Tooltip>
                          </div>
                        )}
                      </Col>

                      {/* <Row gutter={16} align="middle"> */}
                      <Col xs={24} sm={3} md={3} lg={3} span={3}></Col>
                      <Col
                        span={21}
                        style={{
                          // marginLeft: 160,
                          marginTop: "10px",
                        }}
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "samples"]}
                          rules={[{ required: false }]}
                          noStyle
                        >
                          <InputNumber
                            min={1}
                            max={100000000}
                            addonBefore={t("Amount of data")}
                            placeholder="1"
                            style={{ width: 300 }}
                            onKeyPress={handleNumberInput}
                            onChange={(value) => {
                              if (value !== null && value > 100) {
                                props.form.setFieldsValue({
                                  core: 100,
                                });
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                      {/* </Row> */}
                    </Row>
                  </Form.Item>
                ))}

                {/* แสดงปุ่ม Add Dataset ด้านล่าง */}
                {fields.length > 0 && (
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() =>
                        add({
                          name: "",
                          desciption: "",
                          link: "",
                          samples: 0,
                        })
                      }
                      icon={<PlusOutlined />}
                      style={{ width: "100%" }}
                    >
                      {t("Add Dataset")}
                    </Button>
                  </Form.Item>
                )}
              </>
            )}
          </Form.List>
        </Card>
      </Row>
      {/* dataset private */}
      <Row gutter={24} style={{ marginTop: 20 }}>
        <Card
          title={t("Test Dataset (Private)")}
          style={{
            width: "100%",
            backgroundColor: "#F3F3F1",
            borderColor: "#cccccc",
          }}
        >
          <Form.List name="datasetprivate" initialValue={[]}>
            {(fields, { add, remove }) => (
              <>
                {/* แสดงฟิลด์เฉพาะเมื่อ fields.length > 0 */}
                {fields.map((field, index) => (
                  <Form.Item key={field.key} required={false}>
                    <Row gutter={8} align="top">
                      <Col xs={24} sm={3} md={3} lg={3} span={3}>
                        <span>
                          {index + 1}. {t("Dataset")} :{" "}
                        </span>
                      </Col>
                      <Col span={21}>
                        <Form.Item
                          {...field}
                          name={[field.name, "name"]}
                          rules={[
                            {
                              required: false,
                            },
                            {
                              message: "Please input dataset id!",
                            },
                          ]}
                          noStyle
                        >
                          <Input
                            placeholder="Id"
                            autoComplete="off"
                            onKeyPress={(event) => {
                              const regex = /^[A-Za-z0-9_]$/;
                              if (!regex.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onPaste={(event) => {
                              const paste = (
                                event.clipboardData || window.Clipboard
                              ).getData("text");
                              if (!/^[A-Za-z0-9_]+$/.test(paste)) {
                                event.preventDefault();
                              }
                            }}
                            disabled={
                              datasetprivate?.[index]?.link ? true : false
                            }
                            // onChange={(e) => {
                            //   const newName = e.target.value;
                            //   const datasetprivate =
                            //     props.form.getFieldValue("datasetprivate") ||
                            //     [];
                            //   datasetprivate[index].link =
                            //     `/data/datasets/${props.task_id}/${newName}/`;
                            //   props.form.setFieldValue(
                            //     "datasetprivate",
                            //     datasetprivate,
                            //   );
                            // }}
                          />
                        </Form.Item>
                        <div
                          style={{
                            color: "#888",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {t(
                            "Only letters, numbers, and underscores ( _ ) are allowed",
                          )}
                        </div>
                      </Col>

                      <Col xs={24} sm={3} md={3} lg={3} span={3}></Col>
                      <Col span={21} style={{ marginTop: "10px" }}>
                        <Form.Item
                          {...field}
                          name={[field.name, "desciption"]}
                          rules={[
                            { required: false },
                            {
                              message: "Please input display dataset!",
                            },
                          ]}
                          noStyle
                        >
                          <Input placeholder="Display dataset name" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={3} md={3} lg={3} span={3}></Col>
                      <Col span={16} style={{ marginTop: "10px" }}>
                        <Form.Item
                          {...field}
                          name={[field.name, "link"]}
                          rules={[
                            { required: false },
                            {
                              message: "Please input a valid link",
                            },
                          ]}
                          noStyle
                        >
                          <Input
                            readOnly
                            placeholder={`/data/datasets/${props.task_id}/`}
                          />
                        </Form.Item>
                      </Col>

                      {/* current */}
                      {/* <Col span={5} style={{ marginTop: "10px" }}>
                        <Tooltip placement="bottom" title="Delete">
                          <DeleteButtonWithConfirmSubdata
                            onDelete={() => remove(field.name)}
                          />
                        </Tooltip>
                      </Col> */}
                      <Col span={5} style={{ marginTop: "10px" }}>
                        {props.form.getFieldValue("datasetprivate")?.[index]
                          ?.link ? (
                          // หากมีข้อมูลในฟิลด์ link จะแสดงปุ่ม Clear Path
                          <div>
                            {/* <Tooltip placement="bottom" title="Clear Path">
                              <Button
                                onClick={() => {
                                  // ล้างค่า link ใน datasetprivate
                                  const datasetprivate =
                                    props.form.getFieldValue(
                                      "datasetprivate",
                                    ) || [];
                                  datasetprivate[index].link = null; // ล้างค่า link ในรายการที่กำหนด
                                  props.form.setFieldsValue({
                                    datasetprivate,
                                  }); // อัปเดตค่าในฟอร์ม
                                }}
                                icon={"X"}
                                danger
                              ></Button>
                            </Tooltip> */}
                            <Tooltip placement="bottom" title="Delete">
                              <DeleteButtonWithConfirmSubdata
                                onDelete={() => remove(field.name)}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          // หากยังไม่มีข้อมูลในฟิลด์ link จะแสดงปุ่ม Upload
                          <div>
                            <Tooltip placement="bottom" title="Upload2">
                              <UploadButton
                                validateFileSize={validateFileSize}
                                uploading={uploading}
                                setUploading={setUploading}
                                upload_file={upload_file}
                                form={props.form}
                                index={index}
                                task_id={props.task_id}
                                type={
                                  props.form.getFieldValue("datasetprivate")?.[
                                    index
                                  ]?.name
                                }
                                // type="dataset"
                              />
                            </Tooltip>

                            <Tooltip placement="bottom" title="Delete">
                              <DeleteButtonWithConfirmSubdata
                                onDelete={() => remove(field.name)}
                              />
                            </Tooltip>
                          </div>
                        )}
                      </Col>

                      {/* <Row gutter={16} align="middle"> */}
                      <Col xs={24} sm={3} md={3} lg={3} span={3}></Col>
                      <Col
                        span={21}
                        style={{
                          // marginLeft: 160,
                          marginTop: "10px",
                        }}
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "samples"]}
                          rules={[{ required: false }]}
                          noStyle
                        >
                          <InputNumber
                            min={1}
                            max={100000000}
                            addonBefore={t("Amount of data")}
                            placeholder="1"
                            style={{ width: 300 }}
                            onKeyPress={handleNumberInput}
                            onChange={(value) => {
                              if (value !== null && value > 100) {
                                props.form.setFieldsValue({
                                  core: 100,
                                });
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                      {/* </Row> */}
                    </Row>
                  </Form.Item>
                ))}

                {/* แสดงปุ่ม Add Dataset เมื่อไม่มี fields */}
                {fields.length === 0 && (
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() =>
                        add({
                          name: "",
                          desciption: "",
                          link: ``,
                          // link: `/data/datasets/${props.task_id}/`,
                          samples: 0,
                        })
                      }
                      icon={<PlusOutlined />}
                      style={{ width: "100%" }}
                    >
                      {t("Add Dataset")}
                    </Button>
                  </Form.Item>
                )}

                {/* แสดงปุ่ม Add Dataset ด้านล่างเมื่อ fields มีค่า */}
                {fields.length > 0 && (
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() =>
                        add({
                          name: "",
                          desciption: "",
                          link: "",
                          samples: 0,
                        })
                      }
                      icon={<PlusOutlined />}
                      style={{ width: "100%" }}
                    >
                      {t("Add Dataset")}
                    </Button>
                  </Form.Item>
                )}
              </>
            )}
          </Form.List>
        </Card>
      </Row>
    </div>
  );
};

export default DatasetPage;
